import firebase from "firebase/app";
import "firebase/auth";
import "firebase/analytics";

export const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
firebase.initializeApp(config);

// Enable analytics debug mode in development
if (process.env.NODE_ENV === 'development') {
  window.localStorage.setItem('debug', 'firebase:*');
}

// Initialize Analytics with debug mode
const analytics = firebase.analytics();
analytics.setAnalyticsCollectionEnabled(true);

if (process.env.NODE_ENV === 'development') {
  analytics.setUserProperties({debug_mode: true});
  window.gtag('config', process.env.REACT_APP_FIREBASE_MEASUREMENT_ID, {
    debug_mode: true
  });
}

const checkAnalytics = () => {
  analytics.logEvent('test_event', {
    test_param: 'test_value'
  });
  console.log('Test event sent to Firebase Analytics');
};

checkAnalytics();

// Generate or get a persistent user ID
export const getUserId = () => {
  let userId = localStorage.getItem('ab_test_user_id');
  if (!userId) {
    userId = Math.random().toString(36).substring(2, 15);
    localStorage.setItem('ab_test_user_id', userId);
  }
  return userId;
};

// Deterministic hash (djb2)
export const determineVariant = (userId, threshold = 1) => {
  let hash = 5381;
  for (let i = 0; i < userId.length; i++) {
    hash = ((hash << 5) + hash) + userId.charCodeAt(i);
  }
  const normalizedHash = (Math.abs(hash) % 10007) / 10007;
  return normalizedHash < threshold ? 'A' : 'B';
};

// Get the current variant
export const getLandingPageVariant = () => {
  const userId = getUserId();
  const variant = determineVariant(userId);
  console.log('Landing Page Variant Selected:', { variant, userId });
  return variant;
};

export const logExperimentView = (variant) => {
  try {
    const eventParams = {
      experiment_name: 'landing_page_test',
      variant: variant,
      user_id: getUserId()
    };
    console.log('Logging experiment view:', eventParams);
    analytics.logEvent('experiment_impression', eventParams);
    if (window.gtag) {
      window.gtag('event', 'experiment_impression', eventParams);
    }
    return true;
  } catch (error) {
    console.error('Error logging experiment view:', error);
    return false;
  }
};

export const logConversion = (eventName, variant) => {
  try {
    const eventParams = {
      experiment_name: 'landing_page_test',
      variant: variant,
      user_id: getUserId()
    };
    console.log('Logging conversion event:', eventName, eventParams);
    analytics.logEvent(eventName, eventParams);
    if (window.gtag) {
      window.gtag('event', eventName, eventParams);
    }
    return true;
  } catch (error) {
    console.error('Error logging conversion:', error);
    return false;
  }
};

export const testVariantDistribution = (iterations = 1000) => {
  const results = {A: 0, B: 0};
  const userIds = [];
  for(let i = 0; i < iterations; i++) {
    const userId = Math.random().toString(36).substring(2, 15);
    userIds.push(userId);
    const variant = determineVariant(userId);
    results[variant]++;
  }
  console.log('Variant Distribution Test Results:', {
    total: iterations,
    distribution: results,
    percentageA: (results.A / iterations * 100).toFixed(2) + '%',
    percentageB: (results.B / iterations * 100).toFixed(2) + '%'
  });
  // Test persistence - same userId should get same variant
  const testUserId = userIds[0];
  const firstVariant = determineVariant(testUserId);
  const secondVariant = determineVariant(testUserId);
  console.log('Persistence Test:', {
    userId: testUserId,
    firstVariant,
    secondVariant,
    isConsistent: firstVariant === secondVariant
  });
  return results;
};

export default firebase;